import * as React from "react"
import type { IntervalOrigin } from "@digits-graphql/frontend/graphql-bearer"
import useRouter from "@digits-shared/hooks/useRouter"
import useIntervalOrigin from "src/shared/hooks/useIntervalOrigin"

export function usePeriodSelectorActiveOrigin() {
  const contextOrigin = useIntervalOrigin()
  const { search } = useRouter()
  const intervalCount = parseInt(search.get("intervalCount") ?? "", 10) || undefined
  const origin = React.useMemo(
    () => ({ ...contextOrigin, intervalCount: intervalCount }),
    [contextOrigin, intervalCount]
  )

  const state = React.useState<IntervalOrigin>(origin)
  const [_, setActiveOrigin] = state

  const { index, interval, year } = origin
  React.useEffect(() => {
    setActiveOrigin({ index, interval, year, intervalCount })
  }, [index, interval, intervalCount, origin, setActiveOrigin, year])

  return state
}
